import '@ifca-root/react-component/src/assets/styles/components/totalAmountFooter.scss'
import theme from '@ifca-root/react-component/src/assets/theme'
import { useMediaQuery } from '@material-ui/core'
import AppContext from 'containers/App/Store/AppContext'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext } from 'react'

export interface TooltipAmountWithContractSumProps {
  data?: any
  trxType?: any
  module?: string
  docAmt?: any
  detail?: boolean
  ContractSum?: any
  UnbilledAmt?: any
  Amount?: any
}

export const TooltipProforma = (props: TooltipAmountWithContractSumProps) => {
  const {
    data,
    module,
    detail,
    trxType,
    ContractSum,
    UnbilledAmt,
    Amount,
  } = props
  const { globalState, dispatch }: any = useContext(AppContext as any)
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  let itemData = []
  itemData = data

  return (
    <div
      className={detail ? 'totalAmountFooterDetail' : 'totalAmountFooter'}
      style={{
        width:
          isDesktop && globalState.drawerOpen
            ? 'calc(100% - 288px)'
            : !isDesktop
            ? '100%'
            : 'calc(100% - 48px)',
        marginLeft:
          isDesktop && globalState.drawerOpen
            ? '264px'
            : !isDesktop
            ? '0px'
            : '24px',
      }}
    >
      <div>
        <span
          style={{
            fontWeight: 500,
            height: '9px',
            marginLeft: '20px',
            color: 'white',
            float: 'left',
            marginTop: '7px',
            fontSize: '10.5px',
            textDecoration: 'underline',
          }}
        >
          Outstanding balance:
          <span
            style={{
              marginLeft: '3px',
            }}
          />
          {amtStr(UnbilledAmt)}
        </span>
      </div>
      <div>
        <span
          style={{
            fontWeight: 500,
            height: '9px',
            marginLeft: '10px',
            color: 'white',
            float: 'right',
            marginTop: '7px',
            fontSize: '10.5px',
            marginRight: '20px',
            textDecoration: 'underline',
          }}
        >
          Amount:
          <span
            style={{
              marginLeft: '3px',
            }}
          />
          {amtStr(Amount)}
        </span>
      </div>
    </div>
  )
}
